import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { Fragment } from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Star from "@material-ui/icons/StarRounded";
import { withi18n } from "../../../hocs/i18n";

var createInitialState = function createInitialState(max) {
  var initialState = {};
  var i = 0;

  for (i; i < max; i++) {
    initialState[i] = false;
  }

  return initialState;
};

var StarRatingSystem = function StarRatingSystem(_ref) {
  var classes = _ref.classes,
      onClick = _ref.onClick,
      rating = _ref.rating,
      maxScore = _ref.maxScore,
      disabled = _ref.disabled,
      hasPreviousScore = _ref.hasPreviousScore,
      fontSize = _ref.fontSize,
      compact = _ref.compact,
      containerClass = _ref.containerClass;

  var _React$useState = React.useState(rating),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localRating = _React$useState2[0],
      setLocalRating = _React$useState2[1];

  var _React$useState3 = React.useState(createInitialState(maxScore)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      stars = _React$useState4[0],
      setStars = _React$useState4[1];

  var _React$useState5 = React.useState("none"),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      aniState = _React$useState6[0],
      setAniState = _React$useState6[1];

  React.useEffect(function () {
    var val = rating || localRating;
    updateStars(val - 1);
  }, []);
  React.useEffect(function () {
    setLocalRating(rating);
    updateStars(rating - 1);
  }, [rating]);

  var updateStars = function updateStars(hoverIndex) {
    var newStars = {};
    Object.keys(stars).map(function (key) {
      newStars[key] = false;

      if (key <= hoverIndex) {
        newStars[key] = true;
      }
    });
    setStars(newStars);
  };

  var addEvents = function addEvents(key) {
    var updateFunc = function updateFunc() {
      return updateStars(key);
    };

    var changeScoreFunc = function changeScoreFunc() {
      updateStars(Number(key));
      setLocalRating(Number(key) + 1);
      onClick(Number(key) + 1);
      setAniState("start");
    };

    if (!disabled) {
      if (hasPreviousScore) {
        return {
          onClick: changeScoreFunc
        };
      }

      return {
        onMouseOver: updateFunc,
        onFocus: updateFunc,
        onClick: changeScoreFunc
      };
    }

    return {};
  };

  var handleTransitionEnd = function handleTransitionEnd() {
    setAniState("finish");
  };

  var delay = 50;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.starsContainer, " ").concat(containerClass),
    rating: localRating
  }, /*#__PURE__*/React.createElement(Fragment, null, Object.keys(stars).map(function (key, index) {
    var star = stars[key];
    var indexDelay = index * delay;
    var styles = {};

    if (star) {
      switch (aniState) {
        case "start":
          styles.transform = "scale(0.5)";
          styles.transition = "all .1s linear";
          break;

        case "finish":
          styles.transition = "all ".concat(indexDelay, "ms ease-in-out");
          styles.transform = "scale(1.15)";
          break;

        default:
          styles = {};
      }
    }

    return /*#__PURE__*/React.createElement(IconButton, Object.assign({
      classes: {
        root: compact ? classes.compactIconRoot : classes.iconRoot
      },
      key: key,
      disabled: disabled,
      className: classes.button,
      component: "div"
    }, addEvents(key), {
      style: styles,
      onTransitionEnd: handleTransitionEnd
    }), star === true ? /*#__PURE__*/React.createElement(Star, {
      className: classes.star,
      style: {
        fontSize: fontSize
      },
      onTransitionEnd: handleTransitionEnd
    }) : /*#__PURE__*/React.createElement(Star, {
      key: key,
      className: classes.starBorder,
      style: {
        fontSize: fontSize
      }
    }));
  })));
};

var styles = function styles(_ref2) {
  var palette = _ref2.palette;
  var starColor = "#FFB300";
  var starBorderColor = "#D7D7D7";

  if (palette.star) {
    starColor = palette.star.fill;
    starBorderColor = palette.star.border;
  }

  return {
    starsContainer: {
      display: "flex",
      maxHeight: 56,
      alignItems: "center",
      justifyContent: "space-around" // flex: 1

    },
    star: {
      color: starColor
    },
    starBorder: {
      color: starBorderColor
    },
    button: {
      "&:hover, &.Mui-focusVisible": {
        backgroundColor: "transparent"
      }
    },
    iconRoot: {
      padding: 8
    },
    compactIconRoot: {
      padding: 0
    }
  };
};

export default withStyles(styles)(withi18n(StarRatingSystem, "Star Rating System"));
StarRatingSystem.defaultProps = {
  fontSize: 30,
  compact: false
};